import React, { Component } from 'react'
import _ from 'lodash'

class BalanzaInfo extends Component {
  constructor (props) {
    super(props)
    this.defaultFields = [
      'balanza', 'enclavamiento', 'pesaje', 'modoBarreras', 'pesoMinimo', 'pesoMaximo'
    ]
    this.strongFields = ['balanza']
    this.renderField = this.renderField.bind(this)
    this.renderFields = this.renderFields.bind(this)
  }

  renderField ({ field, value, key }) {
    return (
      <div key={key} className={`info-cpa-column`}>
        <div className='info-cpa-label'>{_.startCase(field)}</div>
        <div className={`info-cpa-value`}>
          {value}
        </div>
      </div>
    )
  }

  renderFields (balanza, fields = null) {
    fields = fields || this.defaultFields
    return (
      <div className='info-cpa-row'>
        {
          fields.filter(field => balanza[field])
            .map((field, key) => {
              return this.renderField({ field, value: balanza[field], key })
            })
        }
      </div>
    )
  }

  render () {
    const {
      balanza
    } = this.props

    return (
      <div className='show-cpa-info'>
        {this.renderFields(balanza)}
      </div>
    )
  }
}

export default BalanzaInfo
